import logo from './logo.svg';
import './App.css';
import Login from "./Login";
import Dashboard from "./Dashboard";
import AddUser from "./AddUser";
import AddClient from './Client/AddClient';
import AddTechnician from './AddTechnician';
import AddManager from './Manager/AddManager';
import AddTicket from './Ticket/AddTicket';
import Clients from "./Client/Clients";
import Managers from "./Manager/Managers";
import Departments from "./Department/Departments";
import Designations from "./Designation/Designations";
import Technicians from "./Technician/Technicians";
import AddClientTicket from "./Ticket/AddClientTicket";

function App() {

  const token = localStorage.getItem("token");

  const path = window.location.pathname;

  // Login page
  if (!token) { return <Login />; }

  if (path === "/add-user") { return <AddUser />; }

  if (path === "/AddClient") { return <AddClient />; }

  if (path === "/Technicians") { return <Technicians />; }

  if (path === "/Managers") { return <Managers />; }

  if (path === "/Departments") { return <Departments />; }

  if (path === "/Designations") { return <Designations />; }

  if (path === "/AddTicket") { return <AddTicket />; }

  if (path === "/clients") { return <Clients />; }

  if (path === "/AddClientTicket") { return <AddClientTicket />; }

  return (
    token ? <Dashboard /> : <Login />
  );
}

export default App;
